var vars = require('./core');

module.exports = vars.createClass('Bar', ['getBarsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs/lib/bar.js
// module id = 1048
// module chunks = 0